import * as React from 'react';
import './AppCallout.css';
import { Callout } from '@fluentui/react';

export interface AppProps {}

export interface AppState {
	//
}

class AppCallout extends React.Component<any, AppState> {
	private appCallout = null;
	componentDidMount() {
		setTimeout(() => {
			this.appCallout && this.appCallout.click();
		}, 5000);
	}
	componentWillUnmount() {}
	render() {
		let { text, title, ...other } = this.props;
		return (
			<Callout
				className="wd-callout"
				ariaLabelledBy={'_calloutLabel'}
				ariaDescribedBy={'_calloutDescription'}
				role={'alertdialog'}
				gapSpace={0}
				setInitialFocus={true}
				{...other}>
				{title != null && (
					<div className="ms-CalloutExample-header">
						<h3 className="ms-CalloutExample-title" id={'_calloutLabel'}>
							{title}
						</h3>
					</div>
				)}
				<div
					className="ms-CalloutExample-inner"
					ref={(input) => (this.appCallout = input)}>
					<div className="ms-CalloutExample-content">
						<p className="ms-CalloutExample-subText" id={'_calloutDescription'}>
							{text}
							{this.props.children}
						</p>
					</div>
				</div>
			</Callout>
		);
	}
}

export default AppCallout;
